import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex h-100 align-items-center justify-content-center",
  style: {"z-index":"100000","background-color":"rgba(255, 255, 255, 0.75)","left":"0px","top":"0px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-block text-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border text-success",
    role: "status"
  }),
  /*#__PURE__*/_createElementVNode("h6", null, "Validando")
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "d-flex h-100 align-items-center justify-content-center",
  style: {"z-index":"100000","background-color":"rgba(255, 255, 255, 0.75)","left":"0px","top":"0px"}
}
const _hoisted_5 = { class: "d-block text-center mx-auto" }
const _hoisted_6 = {
  class: "text-center py-3",
  style: {"line-height":"2em"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = {
  key: 2,
  class: "container px-5 py-4"
}
const _hoisted_9 = {
  key: 0,
  class: "d-flex position-fixed w-100 h-100 align-items-center justify-content-center",
  style: {"z-index":"100000","background-color":"rgba(255, 255, 255, 0.75)","left":"0px","top":"0px"}
}
const _hoisted_10 = { class: "d-block text-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "row gy-3 my-3"
}
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "row mt-5" }
const _hoisted_16 = { class: "col-6 col-md-6 d-flex justify-content-start" }
const _hoisted_17 = { class: "col-6 col-md-6 d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppInfoTitles = _resolveComponent("AppInfoTitles")!
  const _component_AppDisclaimer = _resolveComponent("AppDisclaimer")!
  const _component_PersonalDate = _resolveComponent("PersonalDate")!
  const _component_CompanionDetails = _resolveComponent("CompanionDetails")!
  const _component_Documentation = _resolveComponent("Documentation")!
  const _component_TermsAndConditions = _resolveComponent("TermsAndConditions")!
  const _component_AppButtonReturn = _resolveComponent("AppButtonReturn")!
  const _component_AppButtonContinue = _resolveComponent("AppButtonContinue")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.init || _ctx.totalTurnos === null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_ctx.totalTurnos >= 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h4", _hoisted_6, [
              _createTextVNode(" Has llegado a tu máximo, ya tienes programados 2 Test Drive "),
              _hoisted_7,
              _createTextVNode(" el día \"" + _toDisplayString(_ctx.navigation.date?.concatenado) + "\" dentro del predio. Puedes elegir otro día según la disponibilidad. ", 1)
            ]),
            _createVNode(_component_router_link, {
              class: "h5",
              to: { name: 'Home' }
            }, {
              default: _withCtx(() => [
                _createTextVNode("Volver")
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_ctx.loading.status)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("h6", null, _toDisplayString(_ctx.loading.text), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_Form, {
            onSubmit: _ctx.onSubmit,
            onInvalidSubmit: _ctx.onInvalidSubmit
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AppInfoTitles),
              _createVNode(_component_AppDisclaimer),
              _createVNode(_component_PersonalDate, {
                modelValue: _ctx.form.personal,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.personal) = $event))
              }, null, 8, ["modelValue"]),
              (_ctx.navigation.actividad?.aceptaAcompaniantes)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.t('formDatos.titles.subtitle3')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_CompanionDetails, {
                        modelValue: _ctx.form.acompanianteUno,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.acompanianteUno) = $event)),
                        "label-name": "formularios.nombreAcom1.label"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_CompanionDetails, {
                        modelValue: _ctx.form.acompanianteDos,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.acompanianteDos) = $event)),
                        "label-name": "formularios.nombreAcom2.label"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_CompanionDetails, {
                        modelValue: _ctx.form.acompanianteTres,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.acompanianteTres) = $event)),
                        "label-name": "formularios.nombreAcom3.label"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_Documentation, {
                modelValue: _ctx.form.documentacion,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.documentacion) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_TermsAndConditions, {
                modelValue: _ctx.form.terminos,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.terminos) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_AppButtonReturn)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_AppButtonContinue, {
                    disabled: _ctx.loading.status
                  }, null, 8, ["disabled"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "onInvalidSubmit"])
        ]))
}